function sum(items: number[]): number;
function sum<T>(items: T[], getProperty: (item: T) => number): number;
function sum(
  items: (number | unknown)[],
  getProperty?: (item: unknown) => number,
): number {
  return items.reduce((acc: number, item: number | unknown) => {
    if (getProperty) {
      return acc + getProperty(item);
    }

    if (typeof item === "number") {
      return acc + item;
    }

    throw new Error("Must pass array of numbers or provide getter function");
  }, 0);
}

export default sum;
